export default __webpack_public_path__ + "assets/potw-week-a8c73653551ba1c21449545712dba32f.svg";